import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="font-logo text-xl font-extrabold tracking-tight text-background-50">
                97<span className="text-accent-400">影院</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              97影院是面向广大影视爱好者的综合影视资源浏览平台，汇集最新电影、热门电视剧全集与影视资讯，
              帮助用户通过分类、筛选与搜索快速找到想看的作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <span className="inline-block">快速导航</span>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-secondary-200">
              <li><Link to="/" className="transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/category/movie" className="transition-colors hover:text-accent-400">电影库</Link></li>
              <li><Link to="/category/tv" className="transition-colors hover:text-accent-400">电视剧库</Link></li>
              <li><Link to="/search" className="transition-colors hover:text-accent-400">搜索影视</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <span className="inline-block">关于本站</span>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-secondary-200">
              <li><Link to="/about" className="transition-colors hover:text-accent-400">网站介绍</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-accent-400">使用说明</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-accent-400">免责声明</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-accent-400">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 97影院 · 本站为演示站点，所有影视信息均为虚构示例内容。</p>
          <p>不提供任何真实影片播放与下载服务</p>
        </div>
      </div>
    </footer>
  );
}